
export const  getPrefix = (locale) => {
    if(locale === 'fa') return '';
    if(locale === 'en') return '_en';
    if(locale === 'ru') return '_ru';

    return '_UNKNOWN'
}
